<template>
  <div class="templateList">
    <div class="header">
      <div class="header-search">
        <el-input
          class="header-search-item"
          placeholder="搜索内容"
          v-model="key"
          clearable
          @keyup.enter.native="getSearch()"
          @clear="getSearch"
          ><i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="getSearch()"
          ></i
        ></el-input>

        <el-select
          v-model="categoryId"
          placeholder="类别"
          class="header-search-item"
          @change="getSearch"
          clearable
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="operateModule()">新建模板</el-button>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="content" label="内容" :align="alignType">
        </el-table-column>
        <el-table-column label="类别" :align="alignType">
          <template slot-scope="scope">
            <div>{{ scope.row.categoryName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建人" :align="alignType">
          <template slot-scope="scope">
            <div>{{ scope.row.createBy || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" :align="alignType">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" :align="alignType">
          <template slot-scope="scope">
            <el-button type="text" @click="operateModule(scope.row, 'edit')"
              >编辑</el-button
            >
            <el-popconfirm
              confirm-button-text="确认"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              title="是否确认删除该消息模板？"
              @confirm="deleteRow(scope.row.id)"
            >
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          layout="total,prev, pager, next, sizes, jumper"
          :current-page.sync="pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      width="25%"
      class="message-dialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="messageForm"
        :label-width="formLabelWidth"
      >
        <el-form-item label="类别">
          <el-select v-model="form.categoryId" placeholder="请选择，非必填">
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in typeOptions"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            v-model="form.content"
            type="textarea"
            autocomplete="off"
            placeholder="请输入模板内容，必填，最多200字"
            rows="5"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  categoryDictList,
  smsTemplatePage,
  addOrEdit,
  deleteSms
} from '@/common/api/corporateInteraction/messageTemplate'
export default {
  name: 'TemplateList',
  data() {
    return {
      key: '',
      categoryId: '', // 类别 id
      totalRecord: 0,
      pageNum: 1,
      pageSize: 10,
      typeOptions: [],
      dialogFormVisible: false,
      dialogTitle: '新建消息模版',
      tableData: [],
      form: {
        categoryId: '',
        content: ''
      },
      alignType: 'center',
      formLabelWidth: '60px',
      rules: {
        content: [
          {
            required: true,
            message: '请输入模板内容，必填，最多200字',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 200,
            message: '最多200字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {},
  mounted() {
    this.getSearch()
    this.getCategoryList()
  },
  methods: {
    // 操作弹框
    operateModule(row, type) {
      if (type == 'edit') {
        this.dialogTitle = '编辑消息模板'
        this.form.categoryId = row.categoryId ? Number(row.categoryId) : ''
        this.form.content = row.content
        this.form.id = row.id
      } else {
        this.dialogTitle = '新建消息模板'
        this.form = {
          categoryId: '',
          content: '',
          id: ''
        }
      }
      this.dialogFormVisible = true
    },
    // 删除项
    deleteRow(id) {
      const param = {
        id
      }
      deleteSms(param).then((res) => {
        if (res.data.code == '0000') {
          this.$message.success(res.data.msg)
          this.getSearch()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 新增编辑项
    submit() {
      this.$refs.messageForm.validate((valid) => {
        if (valid) {
          this.addOrEdit()
        }
      })
    },
    addOrEdit() {
      const data = {
        ...this.form
      }
      addOrEdit(data).then((res) => {
        if (res.data.code == '0000') {
          this.dialogFormVisible = false
          this.$message.success(res.data.msg)
          this.getSearch()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 获取类别列表
    getCategoryList() {
      categoryDictList().then((res) => {
        if (res.data.code == '0000') {
          this.typeOptions = res.data.data
        }
      })
    },
    // 列表搜索
    getSearch() {
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        key: this.key,
        categoryId: this.categoryId
      }
      smsTemplatePage(param).then((res) => {
        const { data, code, msg } = res.data
        if (code == '0000') {
          this.tableData = data.list
          this.totalRecord = data.total
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getSearch()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.templateList {
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    &-search {
      display: flex;
      &-item {
        margin-right: 20px;
      }
      /deep/.el-input__inner {
        width: 240px;
      }
    }
  }
  .el-table {
    /deep/.el-button {
      margin-right: 10px;
    }
  }
  .table-page {
    margin: 20px 0;
    text-align: right;
  }
}
.message-dialog {
  /deep/.el-input__inner,
  /deep/.el-textarea__inner {
    width: 300px;
  }
}
</style>

